export function closeEncounter(patientId, encounterId = null) {
  return {
    type: 'CLOSE_ENCOUNTER',
    patientId,
    encounterId
  }
}
